import { win } from '../../utils/win';
const Fingerprintjs2 = require('fingerprintjs2/fingerprint2');

let deviceFingerprintGetter;
const maxTimeout: number = 5000;

if (process.env.NODE_ENV === 'test') {
  deviceFingerprintGetter = {
    get: (): Promise<string> => Promise.resolve('fingerprint test value'),
  };
} else {
  deviceFingerprintGetter = {
    get: (): Promise<string> =>
      new Promise((resolve, reject) => {
        Fingerprintjs2.getV18(
          { excludes: { canvas: true, webgl: true } },
          (result) => {
            resolve(result);
          }
        );
        // under some circumstances (e.g. in sled remote tests) getV18 callback is never called
        win.setTimeout(
          () => reject(`Failed to resolve device fingerprint`),
          maxTimeout
        );
      }),
  };
}

export { deviceFingerprintGetter };
